import axios from 'axios';
import UploadFile from '@/js/uploadFile';

const axiosClient = axios.create({
  withCredentials: true,
  baseURL: '/SIMarktdatenShop/rest/vue',
});

export function downloadFile(url, props) {
  return axiosClient({
    url: url,
    method: 'GET',
    responseType: 'blob',
    props: props ? props : undefined,
  });
}

export function saveFile(response, downloadedFileName) {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  if (downloadedFileName) {
    link.setAttribute('download', downloadedFileName);
  } else {
    try {
      let filename = response.headers['content-disposition'].split('filename=')[1].split('.')[0];
      let extension = response.headers['content-disposition'].split('.')[1].split(';')[0];
      link.setAttribute('download', `${filename}.${extension}`);
    } catch (e) {
      // Fallback auf einen Standardnamen fuer die Datei, falls der Header zB nicht vorhanden sein sollte
      link.setAttribute('download', 'downloadfile');
    }
  }
  document.body.appendChild(link);
  link.click();
}

export function setFile(response, dtype, attribut, index, setter) {
  let name;
  try {
    let filename = response.headers['content-disposition'].split('filename=')[1].split('.')[0];
    let extension = response.headers['content-disposition'].split('.')[1].split(';')[0];
    name = `${filename}.${extension}`;
  } catch (e) {
    // Fallback auf einen Standardnamen fuer die Datei, falls der Header zB nicht vorhanden sein sollte
    name = 'downloadfile';
  }
  let ctype = response.headers['content-type'];
  let g = new File([response.data], name, { type: ctype });
  let file = UploadFile.instanceOf(g);
  file.loadUrl(
    `/SIMarktdatenShop/rest/vue/kasse/objektunterlagen/${dtype}/file/${attribut}` +
      (index !== undefined ? `/${index}` : ''),
  );
  file.done();
  setter(file);
}

export default axiosClient;
